import React from "react"

import { useTranslation } from "react-i18next"

import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined"
import { Typography } from "@synapse-analytics/synapse-ui"

import { getTheme } from "../../../../hooks/UseTheme"
import type { BaseBaseNodeProps } from "../../types/interfaces"
import { nodeHelpers } from "../../utils/nodeHelpers"
import { BaseWorkflowNode } from "./base/BaseWorkflowNode"

/**
 * StartNode component represents the starting point of a workflow.
 * Refactored to use BaseWorkflowNode for consistent architecture.
 * Reduced from 85 lines to ~30 lines through use of base component.
 */
export function StartNode(props: Readonly<BaseBaseNodeProps>): React.ReactElement {
  const { menuView } = props

  const theme = getTheme()
  const { t } = useTranslation("workflows", { keyPrefix: "selectionNode" })

  // Get node metadata from the registry
  const metadata = nodeHelpers.getNodeMetadata("StartNode")

  return (
    <BaseWorkflowNode
      id="start-node"
      menuView={menuView}
      nodeType="StartNode"
      title={metadata.title}
      iconProps={{
        element: <FlagOutlinedIcon sx={{ color: theme.palette.base.text[1] }} />,
        className: metadata.iconClassName,
      }}
      width={metadata.width}
      handlesProps={{ showTarget: metadata.showTargetHandle, showSource: metadata.showSourceHandle }}
    >
      <Typography variant="label-bold">{t("nodeBodies.start")}</Typography>
    </BaseWorkflowNode>
  )
}
